import { useNavigate } from "react-router-dom";
import { X, FileText, Upload } from "lucide-react";
import { useEffect, useRef } from "react";
import Modal from "../../Components/Base/Modal";

const SelectWayToDataCollectionCreate = ({ onClose }) => {
  const navigate = useNavigate();
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "unset";
    };
  }, [onClose]);

  return (
    <Modal>
      <div
        ref={modalRef}
        className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden"
      >
        <div className="flex justify-between items-center px-6 py-5 border-b border-slate-200">
          <h2 className="text-xl font-semibold text-slate-900">
            Add DataCollection
          </h2>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 text-2xl font-light size-9 flex items-center justify-center rounded-full hover:bg-slate-100 transition-all duration-200 active:scale-95"
            aria-label="Close modal"
          >
            <X size={20} />
          </button>
        </div>

        <div className="p-6 space-y-5">
          <div
            className="group p-5 border-2 border-slate-200rounded-xl hover:border-emerald-400 hover:bg-emerald-50/50 transition-all duration-300 cursor-pointer active:scale-[0.99] hover:shadow-md"
            onClick={() => navigate("/admin/manualcreatecatacollection")}
          >
            <div className="flex items-center gap-4">
              <div className="size-12 bg-emerald-100rounded-xl flex items-center justify-center group-hover:bg-emerald-200 transition-colors duration-300 group-hover:scale-110">
                <FileText className="text-emerald-600" size={20} />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-slate-800 group-hover:text-emerald-700">
                  Manual Create
                </h3>
              </div>
              <div className="text-slate-300 group-hover:text-emerald-500 transform group-hover:translate-x-1.5 transition-all duration-300">
                →
              </div>
            </div>
          </div>

          <div className="relative flex items-center justify-center">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-slate-200"></div>
            </div>
            <div className="relative bg-white px-4">
              <span className="text-sm text-slate-400 bg-white px-2">OR</span>
            </div>
          </div>

          <div
            className="group p-5 border-2 border-slate-200 rounded-xl hover:border-blue-400 hover:bg-blue-50/50 transition-all duration-300 cursor-pointer active:scale-[0.99] hover:shadow-md"
            onClick={() => navigate("/admin/handlepost")}
          >
            <div className="flex items-center gap-4">
              <div className="size-12 bg-blue-100 rounded-xl flex items-center justify-center group-hover:bg-blue-200 transition-colors duration-300 group-hover:scale-110">
                <Upload className="text-blue-600" size={20} />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-slate-800 group-hover:text-blue-700 ">
                  Add Business Discovery
                </h3>
              </div>
              <div className="text-slate-300 group-hover:text-blue-500 transform group-hover:translate-x-1.5 transition-all duration-300">
                →
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-slate-50 rounded-b-2xl border-t border-slate-200">
          <p className="text-xs text-slate-500 text-center">
            Choose how you want to create your data collection
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default SelectWayToDataCollectionCreate;
